(function () {
  var root = document.getElementById('ovq');
  if (!root) return;

  var MODELS = {};
  try { MODELS = JSON.parse(document.getElementById('ovq-data').textContent); } catch (e) { return; }

  var screens = [].slice.call(root.querySelectorAll('.ovq__s'));
  var bar = document.getElementById('ovq-bar');
  var stepEl = document.getElementById('ovq-step');
  var questions = screens.filter(function (s) { return s.dataset.key; });
  var answers = {}, flags = [], score = 0, model = null, hands = 0, idx = 0;

  function has(s, k) { return s.dataset[k] !== undefined; }

  try {
    var qs = new URLSearchParams(location.search);
    if (qs.get('f')) answers.percorso = qs.get('f');
    if (qs.get('utm_campaign')) answers.campagna = qs.get('utm_campaign');
    if (qs.get('utm_content')) answers.creativo = qs.get('utm_content');
  } catch (e) {}

  var intro = root.querySelector('[data-intro] .ovq__hint');
  if (intro) intro.textContent = 'Rispondi a ' + questions.length + ' domande: ti diciamo se OREVA Pro fa per te. Meno di 2 minuti.';

  var ICON = {
    camion: '<svg viewBox="0 0 24 24"><path d="M1 6h12v10H1zM13 10h4l4 3v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    indietro: '<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
    scudo: '<svg viewBox="0 0 24 24"><path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5z"/><path d="m9 12 2 2 4-4"/></svg>',
    chat: '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.4 8.4 0 0 1-3.8-.9L3 20.5l1.5-5.2A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/></svg>'
  };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function progress() {
    var done = 0, i;
    for (i = 0; i <= idx; i++) { if (screens[i].dataset.key) done++; }
    bar.style.width = Math.max(6, Math.round((idx / (screens.length - 1)) * 100)) + '%';
    if (has(screens[idx], 'result')) { stepEl.textContent = 'Ecco il tuo risultato'; }
    else if (has(screens[idx], 'load')) { stepEl.textContent = 'Un attimo…'; }
    else if (screens[idx].dataset.key) { stepEl.textContent = 'Domanda ' + done + ' di ' + questions.length; }
    else { stepEl.textContent = done ? 'Ci siamo quasi' : 'Iniziamo'; }
  }

  function show(i) {
    if (i < 0 || i >= screens.length) return;
    screens[idx].classList.remove('is-on');
    idx = i;
    screens[idx].classList.add('is-on');
    progress();
    try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { root.scrollIntoView(); }
    if (has(screens[idx], 'load')) runLoader();
    if (has(screens[idx], 'result')) render();
  }

  function next() { show(idx + 1); }

  screens.forEach(function (s) {
    var multi = s.dataset.multi === '1';
    var opts = [].slice.call(s.querySelectorAll('.ovq__o, .ovq__pc, .ovq__bar'));

    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        if (multi) {
          if (b.dataset.none) {
            opts.forEach(function (o) { o.classList.remove('is-sel'); });
            b.classList.add('is-sel');
          } else {
            var none = s.querySelector('[data-none]');
            if (none) none.classList.remove('is-sel');
            b.classList.toggle('is-sel');
          }
          return;
        }
        opts.forEach(function (o) { o.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        answers[s.dataset.key] = b.dataset.val;
        if (b.dataset.score) score += parseInt(b.dataset.score, 10);
        if (b.dataset.model) model = b.dataset.model;
        if (b.dataset.hands) hands = parseInt(b.dataset.hands, 10);
        setTimeout(next, 240);
      });
    });

    var nx = s.querySelector('[data-next]');
    if (nx) {
      nx.addEventListener('click', function () {
        if (multi) {
          var sel = s.querySelectorAll('.is-sel');
          if (!sel.length) { nx.textContent = 'Scegli almeno una risposta'; setTimeout(function(){ nx.textContent = 'Continua'; }, 1400); return; }
          var vals = [];
          [].forEach.call(sel, function (e) {
            vals.push(e.dataset.val);
            if (e.dataset.flag) flags.push(e.dataset.val);
          });
          answers[s.dataset.key] = vals.join(', ');
        }
        next();
      });
    }
  });

  function runLoader() {
    var items = document.querySelectorAll('#ovq-load li');
    var i = 0;
    (function tick() {
      if (i > 0 && items[i - 1]) items[i - 1].classList.add('is-done');
      if (i < items.length) {
        items[i].classList.add('is-now');
        i++;
        setTimeout(tick, 1000);
      } else {
        setTimeout(function () { show(idx + 1); }, 450);
      }
    })();
  }

  function pickModel() {
    return 'pro';
  }

  function render() {
    var out = document.getElementById('ovq-out');
    var m = MODELS[pickModel()];
    answers.esito = m.name;
    answers.punteggio = String(score);

    var med = '';
    if (flags.length) {
      answers.segnali = flags.join(', ');
      med = '<div class="ovq__med"><b>Una cosa prima di ordinare</b>Hai indicato: ' + esc(flags.join(', ').toLowerCase()) +
        '. Conviene farlo vedere a un medico, anche solo per escludere un tappo di cerume. Puoi ordinare lo stesso: hai 120 giorni e il reso è gratuito.</div>';
    }

    send();

    var why = m.why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('');

    out.innerHTML =
      '<p class="ovq__eyebrow">Risultato del quiz</p>' +
      '<h2 class="ovq__h2">Il nostro consiglio per te: ' + esc(m.name) + '</h2>' +
      '<div class="ovq__card">' +
        '<img src="' + esc(m.img) + '" alt="' + esc(m.name) + '" width="700" height="700">' +
        '<div class="ovq__body">' +
          '<span class="ovq__tag">' + esc(m.tag) + '</span>' +
          '<p class="ovq__name">' + esc(m.name) + '</p>' +
          '<p class="ovq__sub">' + esc(m.sub) + '</p>' +
          '<p class="ovq__price">' + esc(m.price) + ' <small>la coppia, destro e sinistro</small></p>' +
          '<ul class="ovq__why">' + why + '</ul>' +
        '</div>' +
      '</div>' +
      med +
      '<button type="button" class="ovq__cta" id="ovq-buy">Ordina ora <span aria-hidden="true">&rarr;</span></button>' +
      '<ul class="ovq__reass">' +
        '<li><i>' + ICON.camion + '</i>Spedizione gratuita</li>' +
        '<li><i>' + ICON.indietro + '</i>120 giorni per il reso</li>' +
        '<li><i>' + ICON.scudo + '</i>Garanzia legale 2 anni</li>' +
        '<li><i>' + ICON.chat + '</i>Assistenza in italiano</li>' +
      '</ul>' +
      '<a class="ovq__link" href="' + esc(m.url) + '">Prima voglio vedere la scheda completa</a>';

    document.getElementById('ovq-buy').addEventListener('click', function () {
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Un attimo…';
      var attrs = {};
      Object.keys(answers).forEach(function (k) { attrs['Quiz ' + k] = answers[k]; });
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', { content_name: m.name, currency: 'EUR' });
        }
      } catch (e) {}
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(m.variant), quantity: 1 }], attributes: attrs })
      }).then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        window.location.href = m.url;
      });
    });
  }

  function send() {
    var payload = {};
    Object.keys(answers).forEach(function (k) { payload[k] = answers[k]; });
    payload.punteggio = score;
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Quiz OREVA completato', payload);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Quiz OREVA completato', payload]);
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'QuizCompletato', { esito: payload.esito || '', percorso: payload.percorso || '', campagna: payload.campagna || '', creativo: payload.creativo || '' });
        window.fbq('track', 'Lead', { content_name: payload.esito || '' });
      }
    } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push({ event: 'quiz_oreva_completato', quiz: payload }); } catch (e) {}
  }

  progress();
})();